import Util from "../libs/Util";
import dayjs from "dayjs";
import MoreToggle from "../libs/MoreToggle";
import PlanSearchMg from "./PlanSearchMg";

export default class PlanListMg {
  static EVENT_LIST_RELOAD = 'eventListReload';
  static PASSENGER_REGEX_LIST = [
    /^adtnum\d+$/,
    /^chdnum\d+$/,
    /^chdage\d+$/,
    /^infnum\d+$/,
    /^infage\d+$/,
    /^roomnum$/
  ];

  constructor() {
    this.el = document.createElement("div");

    this.CL_SHOW = "isShow";

    this.API = LtikeCommon.API.HOTEL.CATALOG;

    this.HOTEL_ID = document.querySelector('[data-hotelid]').dataset.hotelid;

    this.CATALOG_ID = null;
    this.ACCESSKEY = null;

    this.SUBMIT_DATA = null;

    this.controller = null;
    this.isApiCall = false;

    this.insertTarget = document.querySelector('.-js-plan_list');

    this.errorSec = document.querySelector('.js-plans_error');

    this.form = this.insertTarget.closest('form');

    this.hiddenItems = [];

    this.loader = this.insertTarget.closest(".plans").querySelector('.-loader');

    const urlParams = new URLSearchParams(window.location.search);

    this.CATALOG_ID = urlParams.get('catalogid');
    this.ACCESSKEY = urlParams.get('accesskey');

    const planSearchMg = new PlanSearchMg();
    planSearchMg.el.addEventListener(PlanSearchMg.EVENT_SUBMIT,()=>{
      if(this.isApiCall) return;
      this.SUBMIT_DATA = planSearchMg.setSubmitData();
      this.apiCall();
    });

    planSearchMg.el.addEventListener(PlanSearchMg.EVENT_READY,()=>{
      this.SUBMIT_DATA = planSearchMg.setSubmitData();
      this.apiCall();
    });
  }

  async apiCall(){
    this.isApiCall = true;
    this.loader.classList.add(this.CL_SHOW);

    this.errorSec.style.display = '';
    this.insertTarget.style.display = '';

    this.hiddenItems.forEach(item=>{
      item.remove();
    });
    this.hiddenItems = [];

    this.insertTarget.innerHTML = "";

    const params = new URLSearchParams();
    if(this.CATALOG_ID && this.ACCESSKEY) {
      params.set("m","ai");
      params.set("catalogid", this.CATALOG_ID);
      params.set("accesskey", this.ACCESSKEY);
      params.set("subitem","selectable");
    } else {
      params.set("m","direct_c");
    }
    params.set("hotelid", this.HOTEL_ID);

    Object.entries(this.SUBMIT_DATA).forEach(([key, value]) => {
      params.set(key,value);
    });

    try {
      //const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      //await sleep(3000);
      if (this.controller) this.controller.abort();

      this.controller = new AbortController();
      const res = await fetch(`${this.API}?${params.toString()}`,{ signal: this.controller.signal });
      const json = await res.json();
      if(json?.catalog.response.status === "OK"){
        this.apiComplete(json);
      } else {
        const error = json.catalog.response.error.item;
        console.warn('⚠️'+error.errorcode,error.errormessage);
        if(error.errorcode === "CATALOG-HOTEL-0005"){
          this.apiComplete(json);
        } else {
          this.apiError();
        }

      }

    } catch (e){
      //throw e;
      console.error(e);
      this.apiError();
    }
  }

  apiError(){
    this.isApiCall = false;
    this.loader.classList.remove(this.CL_SHOW);
    this.errorSec.style.display = 'block';
    this.insertTarget.style.display = 'none';
  }

  apiComplete(json){
    //console.log(json);

    //部屋料金詳細グループ
    const roomratedetailslist = json.catalog.response.catalogdata.hotel.hotelrooms.hotelroomsitem.roomratedetailslist;
    //選択可能部屋タイプ
    const roomtypeitem = Util.checkItems(roomratedetailslist.selectableroomtypedata4sametype?.roomslist.roomsitem.roomtypelist.roomtypeitem);

    const catalogid = json.catalog.response.catalogid;
    const accesskey = json.catalog.response.accesskey;
    this.CATALOG_ID = catalogid;
    this.ACCESSKEY = accesskey;
    this.SUBMIT_DATA = {...this.SUBMIT_DATA,...{catalogid,accesskey}};

    // hidden項目の値を更新
    Object.entries(this.SUBMIT_DATA).forEach(([key, value]) => {
      let dom = this.form.querySelector(`[name="${key}"]`);
      if (!dom) {
        dom = document.createElement('input');
        dom.setAttribute('type','hidden');
        dom.name = key;
        this.form.appendChild(dom);
      }
      dom.value = value
      this.hiddenItems.push(dom);
    });

    const urlParams = new URLSearchParams(window.location.search);
    const urlCatalogid = urlParams.get('catalogid');
    const urlAccesskey = urlParams.get('accesskey');

    // 直接遷移時は更新せず、通常遷移の場合、更新
    if (!!urlCatalogid && !!urlAccesskey) {
      // URLのパラメータを更新
      Util.setSearchParams(this.SUBMIT_DATA, PlanListMg.PASSENGER_REGEX_LIST);
      // ローカルストレージの値を更新
      this.updateLocalStorageItem();

      // URLのパラメータを更新して、パンくずと戻るボタンのリンクも更新
      this.updateUrlAndLinks();
    }

    //部屋タイプアイテム
    const roomtypes = Util.checkItems(roomratedetailslist.information.response.hotelinformationresponse.hoteldetails.roomtypes.roomtypelist.roomtype);

    const rooms = {};
    const sortRooms = [];
    roomtypes.forEach(item=>{
      item.plans = [];
      rooms[""+item.roomcode] = item;
      sortRooms.push({code:item.roomcode,sort:-1});
    });

    roomtypeitem.forEach((item,index)=>{
      const code = item.roomtypecode;
      rooms[""+code].plans.push(item);

      const room = sortRooms.find(room => room.code === code && room.sort === -1);
      if (room) room.sort = index;
    });

    sortRooms.sort((a, b) => {
      const aSort = a.sort === -1 ? Infinity : a.sort;
      const bSort = b.sort === -1 ? Infinity : b.sort;
      return aSort - bSort;
    });

    //console.log(rooms,roomtypes,roomtypeitem,sortRooms);

    let html = '';

    sortRooms.forEach(item=>{
      html += this.createRoomItemHtml(rooms[item.code],json);
    });

    this.insertTarget.innerHTML = html;

    this.insertTarget.querySelectorAll('.js-more').forEach(el => {
      new MoreToggle(el)
    });

    this.el.dispatchEvent(new CustomEvent(PlanListMg.EVENT_LIST_RELOAD,{detail:rooms}));

    this.isApiCall = false;
    this.loader.classList.remove(this.CL_SHOW);
  }

  /**
   * URLSearchParams から passenger 情報を抽出して、
   * hotel 検索用の passengers 配列形式に変換します。
   *
   * 取得するパラメータは以下の通りです。
   *   adtnum1, chdnum1, chdage1, infnum1, infage1, roomnum
   *   adtnum2, chdnum2, chdage2, infnum2, infage2, ...
   *   adtnum8, chdnum8, chdage8, infnum8, infage8
   * roomnum が指定されていない場合でも、
   * adtnum*,chdnum*,chdage*,infnum*,infage* の番号から
   * 必要な部屋数を判定します。
   *
   * @param {URLSearchParams} searchParams
   * @returns {Array<{adult:number,child:number,ageList:string[]}>|null}
   */
  static getPassengersFromSearchParams(searchParams) {
    const roomIndexes = new Set();
    [...searchParams.keys()].forEach(key => {
      const match = key.match(/^(?:adtnum|chdnum|chdage|infnum|infage)(\d+)$/);
      if (match) {
        roomIndexes.add(Number(match[1]));
      }
    });

    const roomnum = Number(searchParams.get('roomnum')) || Math.max(0, ...roomIndexes);
    if (roomnum === 0) {
      return null;
    }

    const passengers = [];
    for (let i = 1; i <= roomnum; i++) {
      const adult = Number(searchParams.get(`adtnum${i}`));
      const chdnum = Number(searchParams.get(`chdnum${i}`));
      const infnum = Number(searchParams.get(`infnum${i}`));
      const ageList = [];

      const chdage = searchParams.get(`chdage${i}`);
      if (chdage) {
        ageList.push(...decodeURIComponent(chdage).split(',').filter(v => v !== ''));
      }
      const infage = searchParams.get(`infage${i}`);
      if (infage) {
        ageList.push(...decodeURIComponent(infage).split(',').filter(v => v !== ''));
      }

      const child = (Number.isNaN(chdnum) ? 0 : chdnum) + (Number.isNaN(infnum) ? 0 : infnum);
      if (Number.isNaN(adult) && child === 0 && ageList.length === 0) {
        continue;
      }

      passengers.push({
        adult: Number.isNaN(adult) ? 0 : adult,
        child,
        ageList
      });
    }

    return passengers.length ? passengers : null;
  }

  updateLocalStorageItem() {
    // ローカルストレージデータを取得
    const params = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS);
    if (!params) {
      return;
    }

    let parseParams;
    try {
      parseParams = JSON.parse(params);
    } catch (e) {
      return;
    }

    let _url = window.location.href;
    let url = new URL(_url);
    // URLからデータを取得
    let urlCheckinDate = url.searchParams.get("checkindate");
    let urlCheckoutDate = url.searchParams.get("checkoutdate");
    if (urlCheckinDate != null && urlCheckinDate !== '') {
      parseParams.date.going = urlCheckinDate;
    }
    if (urlCheckoutDate != null && urlCheckoutDate !== '') {
      parseParams.date.back = urlCheckoutDate;
    }

    const passengers = PlanListMg.getPassengersFromSearchParams(url.searchParams);
    if (passengers) {
      parseParams.passengers = passengers;
    }

    // ローカルストレージデータを更新
    Util.localstrageSetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS, JSON.stringify(parseParams));
  }

  updateUrlAndLinks(){
    const searchParams = Util.getSearchParams();
    searchParams.set('m', 'r');
    const queryString = searchParams.toString();

    // パンくずリンクを更新
    const breadcrumbLink = document.querySelector('#js-breadcrumb_search_link');
    if (breadcrumbLink) {
      breadcrumbLink.href = `${breadcrumbLink.href.split('?')[0]}?${queryString}`;
    }

    // 戻るボタンのリンクを更新
    const backLink = document.querySelector('#js-back_to_search_link');
    if (backLink) {
      backLink.href = `${backLink.href.split('?')[0]}?${queryString}`;
    }
  }

  createRoomItemHtml(_data,_json){
    const image = (Util.checkItems(_data.roomimages.roomimagelist.roomimage))[0]?.href ?? '';

    let exBed = '';
    if(_data.plans.length > 0){
      if(_data.plans[0].rateinfos.rateinfo.included){
        switch (_data.plans[0].rateinfos.rateinfo.included){
          case "Extra Bed":
            exBed = LtikeCommon.HOTEL.TEXT.EX_BED;
            break;
        }
      }
    }

    return `
    <section class="plan">
      <div class="-detail">
        <figure><img src="${image}" loading="lazy" alt="" /></figure>
        <div class="-info">
          <h3 class="-name">${_data.description}</h3>
          ${_data.max_occupancy_per_room ? `<div class="-person">利用人数 ${_data.max_occupancy_per_room}名</div>`:''}
          <div class="-bed">${_data.bed_type}${exBed}</div>
          <div class="-btn_more"><button type="button" class="js-dialog_roomdetail" data-roomcode="${_data.roomcode}">部屋の詳細を見る</button></div>
        </div>
      </div>
      <div class="-list">${this.createPlanItemHtml(_data,_json)}</div>
    </section><!-- /plan -->
    `;
  }

  createPlanItemHtml(_data,_json){
    if(_data.plans.length === 0){
      return `
      <div class="-no_item">
        <p>ご案内できるプランがありません。条件を変更して再検索してください。</p>
        <div class="-btn_research"><a href="#plans">宿泊日を変更して再検索</a></div>
      </div>
      `;
    }

    let html = '';

    let isMore = _data.plans.length > 2;
    _data.plans.forEach((item,index) => {
      if(isMore && index === 2) html += `<div class="-more" data-more_id="room_plan_more_${_data.roomcode}">`;
      const tags = Util.checkItems(item.valueadds.valueaddlist.valueadd);

      const rateinfo = item.rateinfos.rateinfo;
      const chargeinfo = rateinfo.chargeablerateinfo;

      let total = chargeinfo.total;

      const pontaBonus = parseInt(rateinfo.pontapointareaadd) + parseInt(rateinfo.pontapointhoteladd);

      const cancelpolicy = rateinfo.cancelpolicyinfo4etour;

      const regex = /(\d{4}-\d{2}-\d{2})の前日までにキャンセルすると、キャンセル料金は一切かかりません。/;
      const match = cancelpolicy.match(regex);
      let isCancel = false;
      let cancelMsg = '返金不可';
      if(match){
        const dateStr = match[1];
        const previousDay = dayjs(dateStr)
          .subtract(1, 'day')
          .format('YYYY年MM月DD日');
        cancelMsg = `${previousDay}までキャンセル無料`;
        isCancel = true;
      }
      if (cancelpolicy.startsWith("全ての予約にキャンセル料免除が適用されます。")) {
        cancelMsg = `当日のチェックインまでキャンセル無料`;
        isCancel = true;
      }
      // キャンセル無料の場合は、事務手数料が返金対象外である旨を文末に追記
      const addCancelPolicy = isCancel ? "※事務手数料はご返金対象外となります。" : "";

      let discountHtml = '';

      const campaign = rateinfo.campaign;
      if(campaign && campaign.price !== ""){
        let cpData = null;
        const cpCode = _json.catalog.response.catalogdata.hotel.hotelrooms.campaigncode;
        Util.checkItems(_json.catalog.response.catalogdata.hotel.campaign.campaignlist.campaignitem).forEach(item=>{
          if(item.code === cpCode) cpData = item;
        });
        total = campaign.payment;
        discountHtml = `
<div class="-coupon"><div>現地で使える地域共通クーポン${parseInt(campaign.gotocoupon).toLocaleString()}円分付き</div></div>
<div class="-discount"><div>${cpData.name}${parseInt(campaign.discount).toLocaleString()}円分適用済み</div><div>￥${parseInt(campaign.price).toLocaleString()}</div></div>`;
      }
      //console.log("campaign",campaign);

      const affiliate = rateinfo.affiliate_discount;
      if(affiliate){
        total = affiliate.payment;
        discountHtml = `<div class="-discount"><div>${_json.catalog.response.catalogdata.hotel.affiliate.name}${parseInt(affiliate.discount_total).toLocaleString()}円分適用済み</div><div>￥${parseInt(affiliate.price).toLocaleString()}</div></div>`;
      }
      //console.log("affiliate",affiliate);

      html += `
      <div class="-item">
      ${tags.length > 0 ? `
        <ul class="-tags">
          ${tags.map(tag => `<li>${tag.description}</li>`).join("")}
        </ul>
      `:''}
        <div class="-wrap">
        ${discountHtml}
          <div class="-price">
            <div class="-v">￥${parseInt(total).toLocaleString()}</div>
            <div class="-note">
              <span class="-txt">税・サービス料 ￥${parseInt(chargeinfo.surchargetotal).toLocaleString()}含む</span>
              <span class="-ponta">${parseInt(rateinfo.pontapoint).toLocaleString()}ポイント${pontaBonus > 0? ` + ${parseInt(pontaBonus).toLocaleString()}ボーナスポイント` : ''}</span>
            </div>
          </div>
          <div class="-cancel${isCancel?'':' -ng'}">${cancelMsg}</div>
          <div class="-footer">
            <button type="button" class="-cancel_policy js-tooltip" data-text="${cancelpolicy+addCancelPolicy}">キャンセルポリシー</button>
            <div class="-btn_submit"><button type="submit" name="sameroomtypeitemid" value="${item.roomtypeid}">予約に進む</button></div>
          </div>
        </div>
      </div>
      `;
    });
    if(isMore){
      html += `</div><div class="-btn_more"><button type="button" class="js-more" data-target_id="room_plan_more_${_data.roomcode}"><span>プランをすべて表示する（他${_data.plans.length - 2}件）</span></button></div>`;
    }

    return html;
  }
}
